"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FontWeights = void 0; // START Theme typings

var FontWeights = {
  thin: "100",
  extraLight: "200",
  light: "300",
  normal: "400",
  medium: "500",
  semiBold: "600",
  bold: "700",
  extraBold: "800",
  heavy: "900"
};
exports.FontWeights = FontWeights;